const possibleTypes = {
  Template: ["Process", "Task"],
  UserGroupResult: ["User", "Group"],
}

export { possibleTypes }
